import { Tab } from '../../types/tab';

export const tabDatabase: {[key: string]: Tab} = {
    '/api/tabs/1': {
        key: '/api/tabs/1',
        name: 'Vocale Concerto®',
        successor: '/api/tabs/2',
        description: '1dsdsdsdsdsd',
    },
    '/api/tabs/2': {
        key: '/api/tabs/2',
        name: 'PAKIET Vocale Gold',
        successor: '/api/tabs/3',
        description: '2dsdsdsdsdsd',
    },
    '/api/tabs/3': {
        key: '/api/tabs/3',
        name: 'PAKIET Vocale Premium',
        description: '3dsdsdsdsdsd',
    },
};